import(/* webpackMode: "eager" */ "/app/fe-webapp-next/app/global-error.tsx");
